import { Link, usePage } from "@inertiajs/react";
import { Coins } from "lucide-react";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar.tsx";
import { bizminer_app_credits_path } from "@/routes";
import type { BizminerInertiaSharedProps } from "@/types/inertia.ts";

interface CreditsWidgetProps {
  credits: number;
}

export function CreditsWidget({ credits }: CreditsWidgetProps) {
  const { component } = usePage<BizminerInertiaSharedProps>();

  const isActive = component === "Bizminer/App/Credits/Index";

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton asChild isActive={isActive}>
          <Link
            href={bizminer_app_credits_path(undefined, {
              account_id: undefined,
            })}
          >
            <Coins className="h-4 w-4" />
            {credits} Credits
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
